import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Button from '@profile/src/Components/Button_V2';
export let ButtonType;

(function (ButtonType) {
  ButtonType["AVAILABLE"] = "Available";
  ButtonType["RENTED_OUT"] = "Rented Out";
})(ButtonType || (ButtonType = {}));

const HeaderTab = ({
  status,
  onChange
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Button, {
    className: classNames(styles.button, status === ButtonType.AVAILABLE && styles.active),
    onClick: () => onChange(ButtonType.AVAILABLE),
    title: "All"
  }), /*#__PURE__*/React.createElement(Button, {
    className: classNames(styles.button, status === ButtonType.RENTED_OUT && styles.active),
    title: "Rented Out",
    onClick: () => onChange(ButtonType.RENTED_OUT)
  }));
};

export default HeaderTab;